import React from 'react'
import { appSettings } from '../config/settings'
import { Icon } from '@ztechapps/webui.util'

export const EmailLink = ({
  className,
  email,
  onClick,
}: {
  className?: string
  email?: string
  onClick?: (e) => void
}) => {
  email = email ?? appSettings.supportEmail

  return (
    <a href={`mailto:${email}`} className={className} onClick={onClick}>
      <Icon name="envelope" /> {email}
    </a>
  )
}
